import React from 'react';
import { ContentArea } from '@styles/common';
import ComboBoxGames from '@screens/jackpot.winners/jackpot.winners.comboboxes';
import { useGame } from '@domain/game.selection/game.selection.hook';
import { GameType } from '@domain/game.selection/types/game.type';
import JackpotWinnersRex from '@screens/jackpot.winners/jackpot.winners.list.rex';

const JackpotWinners = () => {
  const game = useGame();
  return <ContentArea>{game.type === GameType.Praia ? <ComboBoxGames /> : <JackpotWinnersRex />}</ContentArea>;
};

export default JackpotWinners;
